import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa6";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TextField from "@mui/material/TextField";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

import { red } from "@mui/material/colors";
import "../style/cart.css";
import "../style/default.css";

function Cart() {
  const baseURL = process.env.REACT_APP_BASE_URL;

  // Step 1: Create state for the cart items
  const [cartItems, setCartItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [totalQuan, setTotalQuan] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [productLink, setProductLink] = useState(
    "http://thevintagecollective.shop/"
  );

  const rows = [];

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const response = await fetch(`${baseURL}/cart-view`, {
          method: "GET",
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch cart data");
        }

        const data = await response.json();

        setCart(data.cart || []);
        setCartItems(data.cartItems || []);

        setTotalPrice(
          data.cartItems.reduce(
            (acc, item) =>
              acc +
              ((item?.prod_sale ? item?.prod_sale : item.prod_price) || 0) *
                (item.prod_quan || 0),
            0
          )
        );

        setTotalQuan(
          data.cartItems.reduce((acc, item) => acc + (item.prod_quan || 0), 0)
        );
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    fetchCartItems();
  }, []);

  const removeItemFromCart = async (prodIdToRemove) => {
    const updatedCartItems = cartItems.filter(
      (item) => item.prod_id !== prodIdToRemove
    );

    const updatedCart = cart.filter(
      (item) => String(item.prod_id) !== String(prodIdToRemove)
    );
    console.log("updatedCart:", updatedCart);
    try {
      const response = await fetch(`${baseURL}/user/cart`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cartItems: updatedCart }),
        credentials: "include",
      });

      if (!response.ok) throw new Error("Failed to update cart");

      const data = await response.json(); // wait for JSON response

      // Assuming your backend sends something like { message: "Cart updated" }
      alert(data.message || "Cart updated successfully!");
      window.location.reload();

      setCartItems(updatedCartItems); // Update UI after successful backend update
    } catch (error) {
      console.error("Error updating cart:", error);
      alert("There was an error updating the cart.");
    }
  };

  // Recalculate total price whenever cartItems updates
  useEffect(() => {
    if (cartItems && cartItems?.length > 0) {
      setTotalPrice(
        "₱" +
          cartItems
            .reduce(
              (acc, item) =>
                acc +
                ((item?.prod_sale ? item?.prod_sale : item.prod_price) || 0) *
                  (item.prod_quan || 0),
              0
            )
            .toLocaleString("fil-PH")
      );

      setTotalQuan(
        cartItems.reduce((acc, item) => acc + (item.prod_quan || 0), 0)
      );
    }
  }, [cartItems]);

  const handleQuantityChange = async (prodId, newQuantity) => {
    if (!isNaN(newQuantity)) {
      const clamped = Math.max(1, Math.min(20, newQuantity));
      // Safely update the UI cartItems state
      setCartItems((prevCartItems) =>
        prevCartItems.map((item) =>
          item.prod_id === prodId ? { ...item, prod_quan: clamped } : item
        )
      );

      // Safely update the backend cart (just prod_id + prod_quan)
      setCart((prevCart) => {
        const updatedCart = prevCart.map((item) =>
          item.prod_id.toString() === prodId.toString()
            ? { ...item, prod_quan: clamped }
            : item
        );

        // Send the updated cart to the backend
        fetch(`${baseURL}/user/cart`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cartItems: updatedCart }), // Make sure this structure matches backend expectations
          credentials: "include",
        }).catch((error) => {
          console.error("Error updating cart:", error);
        });

        return updatedCart; // 👈 Important: return the updated state!
      });
    }
  };

  if (!cartItems || cartItems.length <= 0) {
    return (
      <div>
        <h1>Cart</h1>
        See the world, capture its wonders. Start with the camera and film gear
        in your cart!
      </div>
    );
  } else {
    return (
      <div>
        {" "}
        <h1>Cart</h1>
        <TableContainer component={Paper}>
          <Table sx={{ width: { md: "100%" } }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left"></TableCell>
                <TableCell align="left">Product Description</TableCell>
                <TableCell
                  sx={{ display: { xs: "none", sm: "block" } }}
                  align="center"
                >
                  Quantity
                </TableCell>
                <TableCell align="center">Price</TableCell>
                {/* <TableCell align="center">Total Price</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {cartItems?.map((items) => (
                <TableRow
                  key={items.prod_id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row" align="center">
                    <a
                      className="productLink"
                      href={productLink + "product/" + items.prod_id}
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <img
                        src={JSON.parse(items.prod_image)[0]}
                        alt={items.prod_name}
                        style={{ width: "75px" }}
                      />{" "}
                    </a>
                  </TableCell>
                  <TableCell align="left">
                    <a
                      className="productLink"
                      href={productLink + "product/" + items.prod_id}
                      rel="noopener noreferrer"
                    >
                      {items.prod_name && items.prod_name.length > 30
                        ? items.prod_name.slice(0, 30) + "..."
                        : items.prod_name}{" "}
                      <Typography
                        variant="subtitle2"
                        sx={{ display: { xs: "block", sm: "none" } }}
                      >
                        x {items.prod_quan}
                      </Typography>
                    </a>
                    <br />
                    {items.prod_category}
                    <br />
                    {items.prod_preorder === "yes" ? (
                      <Chip
                        label="Pre-Order"
                        size="small"
                        color="warning"
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      ""
                    )}
                    <br />
                    <button
                      className="remove minimalBtn "
                      onClick={() => removeItemFromCart(items.prod_id)}
                    >
                      {/* <RemoveCircleIcon sx={{ fill: red[500] }} /> */}
                      Remove
                    </button>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      display: { xs: "none", sm: "block", md: "block" },
                    }}
                  >
                    <TextField
                      type="number"
                      variant="outlined"
                      InputProps={{
                        inputProps: {
                          min: 1,
                          max: 20,
                          step: 1,
                        },
                      }}
                      value={items.prod_quan}
                      onChange={(e) =>
                        handleQuantityChange(
                          items.prod_id,
                          Number(e.target.value)
                        )
                      }
                      sx={{
                        display: { xs: "none", sm: "none", md: "block" },
                      }}
                    />
                    {/* // For mobile */}
                    <Box
                      display="flex"
                      alignItems="center"
                      alignContent={"center"}
                      sx={{
                        display: { xs: "none", sm: "flex", md: "none" },
                      }}
                    >
                      <Box
                        component="button"
                        onClick={() =>
                          handleQuantityChange(
                            items.prod_id,
                            Math.max(1, items.prod_quan - 1)
                          )
                        }
                        sx={{
                          cursor: "pointer",
                          fontSize: "small",
                        }}
                      >
                        −
                      </Box>

                      <TextField
                        type="number"
                        variant="outlined"
                        value={items.prod_quan}
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: 20,
                            step: 1,
                          },
                        }}
                        onChange={(e) =>
                          handleQuantityChange(
                            items.prod_id,
                            Math.max(1, Number(e.target.value))
                          )
                        }
                        sx={{ width: "50px", textAlign: "center", mx: 1 }}
                      />

                      <Box
                        component="button"
                        onClick={() =>
                          handleQuantityChange(
                            items.prod_id,
                            items.prod_quan + 1
                          )
                        }
                        sx={{
                          fontSize: "small",
                          cursor: "pointer",
                        }}
                      >
                        +
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    {/* ₱
                    {items.prod_sale.toLocaleString("fil-PH") ||
                      items.prod_price.toLocaleString("fil-PH")} */}
                    {items.prod_sale > 0 ? (
                      <span>
                        <strike>
                          <b>₱{items.prod_price.toLocaleString("fil-PH")}</b>
                        </strike>{" "}
                        <b style={{ color: "red" }}>
                          ₱{items.prod_sale.toLocaleString("fil-PH")}
                        </b>
                      </span>
                    ) : (
                      <b>₱{items.prod_price.toLocaleString("fil-PH")}</b>
                    )}
                  </TableCell>
                  {/* <TableCell align="center">
                  ₱
                  {(items.prod_price * items.prod_quan).toLocaleString(
                    "fil-PH"
                  )}
                </TableCell> */}
                </TableRow>
              ))}
              {/* <TableRow>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="center">
                {" "}
               
              </TableCell>
            </TableRow> */}
              <TableRow>
                <TableCell colSpan={3} align="right">
                  <h4>Total</h4>
                </TableCell>

                <TableCell align="center">{totalPrice}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <div className="cart_footer">
            <div>
              <span></span> <span></span>
            </div>
            <Link to="/checkout">
              <button className="buttons">Checkout ({totalQuan})</button>
            </Link>
          </div>
        </TableContainer>
      </div>
    );
  }
}

export default Cart;
